import React from "react";
import { Helmet } from "react-helmet-async";

const NotFound = () => {
    return (
        <>
            <Helmet>
                <title>404 - Page Not Found | Bonvoy Tourism</title>
            </Helmet>
            <div
                style={{
                    boxShadow: "0 0 0 100vmax #090c0d",
                    clipPath: "inset(0 -100vmax)",
                }}
                className="bg-[#090c0d] flex flex-col items-center justify-center min-h-screen">
                <h1 className="text-4xl text-white font-bold">404</h1>
                <p className="text-lg text-white mt-4">Page Not Found</p>
                <a href="/" className="mt-6 text-white hover:text-[#ff9219] transition">Go Back Home</a>
            </div>
        </>
    );
};

export default NotFound;